import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from '@colonist/ui';
import { TableTabs } from '@colonist/ui-platform';
import { FriendsTable } from './FriendsTable/FriendsTable.tsx';
import { IncomingFriendRequestTable } from './FriendRequestTables/IncomingFriendRequestTable/IncomingFriendRequestTable.tsx';
import { OutgoingFriendRequestTable } from './FriendRequestTables/OutgoingFriendRequestTable/OutgoingFriendRequestTable.tsx';
import styles from './FriendsTab.module.scss';
export const FriendsTab = ({ friends, requests, sentRequests, onUserClick, onGiftClick, onAccept, onDecline, onCancel })=>{
    const { t } = useTranslation();
    const [activeTabId, setActiveTabId] = useState('friends');
    const getTabLabel = useCallback((titleKey, count)=>{
        const title = t(titleKey);
        if (count == 0) return title;
        return `${title} (${count})`;
    }, [
        t
    ]);
    const tabs = useMemo(()=>[
            {
                id: 'friends',
                label: getTabLabel('strings:profilePage.friends.title', friends.length),
                testId: 'profile-friends-subtab-friends'
            },
            {
                id: 'requests',
                label: getTabLabel('strings:profilePage.friends.tabs.requests.title', requests.length),
                testId: 'profile-friends-subtab-requests'
            },
            {
                id: 'sentRequests',
                label: getTabLabel('strings:profilePage.friends.tabs.requestsSent.title', sentRequests.length),
                testId: 'profile-friends-subtab-sent-requests'
            }
        ], [
        friends.length,
        requests.length,
        sentRequests.length,
        getTabLabel
    ]);
    const handleTabChange = (tabId)=>{
        setActiveTabId(tabId);
    };
    const getActiveTable = ()=>{
        if (activeTabId == 'requests') {
            return /*#__PURE__*/ React.createElement(IncomingFriendRequestTable, {
                requests: requests,
                onUserClick: onUserClick,
                onAccept: onAccept,
                onDecline: onDecline
            });
        }
        if (activeTabId == 'sentRequests') {
            return /*#__PURE__*/ React.createElement(OutgoingFriendRequestTable, {
                requests: sentRequests,
                onUserClick: onUserClick,
                onCancel: onCancel
            });
        }
        return /*#__PURE__*/ React.createElement(FriendsTable, {
            friends: friends,
            onUserClick: onUserClick,
            onGiftClick: onGiftClick
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container,
        "data-testid": "profile-friends-tab"
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.tabsHeader
    }, /*#__PURE__*/ React.createElement(TableTabs, {
        activeTabId: activeTabId,
        tabs: tabs,
        onTabChange: handleTabChange,
        size: "md"
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.tableContainer
    }, getActiveTable()));
};
